import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, Clock, AlertTriangle, CheckCircle2, Wallet, TrendingUp, Truck, Phone, Receipt, MessageSquare, Eye } from "lucide-react";
import { api, formatPrice, STATUS_LABELS } from "@/lib/api";

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="text-ink-300">Chargement…</div>;

  const cards = [
    { label: "Demandes aujourd'hui", value: s.today_count, Icon: FileText },
    { label: "En attente", value: s.pending, Icon: Clock },
    { label: "Urgentes", value: s.urgent, Icon: AlertTriangle, accent: true },
    { label: "En cours", value: s.in_progress, Icon: Truck },
    { label: "Terminées (jour)", value: s.completed_today, Icon: CheckCircle2 },
    { label: "Chauffeurs", value: s.drivers, Icon: Truck },
    { label: "Devis simulés", value: s.quotes ?? 0, Icon: Receipt },
    { label: "Messages contact", value: s.contact_messages ?? 0, Icon: MessageSquare },
    { label: "Pages vues (total)", value: (s.pageviews ?? 0).toLocaleString("fr-FR"), Icon: Eye },
    { label: "CA du jour", value: formatPrice(s.revenue_today), Icon: Wallet },
    { label: "CA du mois", value: formatPrice(s.revenue_month), Icon: TrendingUp },
  ];

  return (
    <div>
      <div className="font-heading text-3xl lg:text-4xl font-black uppercase tracking-tight">Tableau de bord</div>
      <div className="h-1 w-16 bg-brand mt-2 mb-6" />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="admin-stats-cards">
        {cards.map((c) => (
          <div key={c.label} className={`p-5 border ${c.accent ? "border-brand bg-brand/5" : "border-ink-700 bg-ink-900"}`}>
            <c.Icon className={c.accent ? "text-brand" : "text-ink-400"} size={20} />
            <div className="font-heading text-3xl font-black mt-3">{c.value}</div>
            <div className="text-ink-300 text-xs uppercase tracking-wider mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="mt-8">
        <div className="flex items-center justify-between mb-3">
          <div className="font-heading text-xl font-bold uppercase tracking-tight">Dernières demandes</div>
          <Link to="/admin/demandes" className="text-brand text-sm font-bold uppercase tracking-wider">Voir toutes →</Link>
        </div>
        <div className="bg-ink-900 border border-ink-700 overflow-x-auto">
          <table className="w-full text-sm whitespace-nowrap">
            <thead className="bg-ink-800 text-ink-300 uppercase text-xs tracking-wider">
              <tr><th className="text-left px-4 py-3">N°</th><th className="text-left px-4 py-3">Client</th><th className="text-left px-4 py-3">Service</th><th className="text-left px-4 py-3">Téléphone</th><th className="text-left px-4 py-3">Statut</th><th className="text-right px-4 py-3">Estimé</th></tr>
            </thead>
            <tbody className="divide-y divide-ink-700">
              {(s.last_requests || []).map((r) => (
                <tr key={r.id} className="hover:bg-ink-800">
                  <td className="px-4 py-3"><Link to={`/admin/demandes/${r.id}`} className="text-brand font-bold">{r.request_number}</Link></td>
                  <td className="px-4 py-3">{r.customer_name}</td>
                  <td className="px-4 py-3">{r.service_type}</td>
                  <td className="px-4 py-3"><a href={`tel:${r.customer_phone}`} className="inline-flex items-center gap-1 text-ink-200 hover:text-brand"><Phone size={12} />{r.customer_phone}</a></td>
                  <td className="px-4 py-3"><span className="bg-ink-800 border border-ink-700 px-2 py-1 text-xs">{STATUS_LABELS[r.status] || r.status}</span></td>
                  <td className="px-4 py-3 text-right">{formatPrice(r.estimated_price)}</td>
                </tr>
              ))}
              {!s.last_requests?.length && <tr><td colSpan={6} className="text-center py-8 text-ink-400">Aucune demande</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
